/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        var pswpElement = jQuery('.pswp').get(0);
        
        var gallery
        var items = []
        var options = {
            index: 0,
            addCaptionHTMLFn: function(item, captionEl, isFake) {
                capContainer = jQuery('.pswp__caption__center', jQuery(captionEl));
                
                jQuery('.painting-title', capContainer).html(item.title);
                jQuery('.painting-info', capContainer).html(item.info);
                return true;
            },        
        };

        var galleryImageCounter = 0;

        jQuery('.fancybox').each(function(i) {
            var galleryImage = jQuery(this)
            var sequenceType = galleryImage.data('sequence-type');
            if(sequenceType == 'static' || sequenceType == 'animated') {
              var currentGalleryImageIndex = galleryImageCounter
              items.push({
                src: galleryImage.attr("href"),
                w: galleryImage.data('image-width'),
                title: galleryImage.attr("title"),
                info:  galleryImage.data('add-info'),
                h: galleryImage.data('image-height')
              });
              galleryImage.click(function(e) {
                  e.preventDefault();
                  options.index = currentGalleryImageIndex
                  gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options );
                  gallery.init();
              })
              galleryImageCounter++;
            } else {
              // Movie
              if(sequenceType === 'youtube') {
                console.log('youtube');
                galleryImage.modalVideo();
              } else if(sequenceType === 'vimeo'){
                console.log('vimeo');
                galleryImage.modalVideo({channel:'vimeo'});
              } 
              jQuery(this).click(function(e) {
                e.preventDefault();
              })
          }
        })

        $('#btnSubmitCapture').click(function(e) {
          e.preventDefault();
          $('#myModal').modal()
        })

        $('#btnGetUpdates').click(function(e) {
          e.preventDefault();
          $('#subscribeModal').modal()
        })

        // Get updates form
        var updatesForm = $('form.updates-form');
        $('form.updates-form').submit(function(event) {

            $('.help-block', updatesForm).remove();
            updatesForm.addClass('submitting');

            var name = $('input[name=name]', updatesForm);
            var email = $('input[name=email]', updatesForm);
            var formMessage = $('p.message', updatesForm);
            var formData = {
                'action': 'add_newsletter_subscriber',
                'name': name.val(),
                'email': email.val()
            };

            $.ajax({
              type        : 'POST',
              url         : "/wp/wp-admin/admin-ajax.php",
              data        : formData,
              dataType    : 'json',
              encode      : true
            })
              .done(function(response) {
                if(response.success === true) {
                  updatesForm.addClass('subscribed');
                  formMessage.html(response.message);
                  updatesForm.removeClass('submitting');
                } else {
                  updatesForm.removeClass('submitting');
                  updatesForm.addClass('failed');
                  formMessage.html(response.message);
                }
              });

            event.preventDefault();
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'post_type_archive_capture': {
      init: function() {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
